export interface yAxis {
  [id: string]: string;
}

function configs(
  labels: any,
  datasets: any,
  stacked?: boolean,
  xAxis?: string,
  yAxis?: yAxis,
  xMinMax?: { min: number; max: number; ticks?: number[] },
  tooltipPrecision?: number,
  legendPosition?: "top" | "left" | "bottom" | "right" | "chartArea"
) {
  const yAxes = yAxis
    ? Object.entries(yAxis).reduce((acc, [id, title], i) => {
        acc[id] = {
          position: i % 2 === 0 ? "left" : "right",
          title: {
            display: true,
            text: title,
          },
          ticks: {
            color: "black",
          },
        };
        return acc;
      }, {} as { [key: string]: any })
    : {
        y: {
          stacked: stacked ?? false,
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
            color: "#0000005c",
          },
          ticks: {
            display: true,
            padding: 10,
            color: "black",
            font: {
              size: 14,
              family: "Roboto",
              style: "normal",
              lineHeight: 2,
            },
            callback: (value: number) => {
              return new Intl.NumberFormat("en-US").format(value);
            },
          },
        },
      };

  return {
    data: {
      labels,
      datasets: [...datasets],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: legendPosition ?? "chartArea",
          align: "start",
        },
        tooltip: {
          callbacks: {
            title: function (context: any) {
              const label = String(context?.[0]?.label ?? "").trim();
              if (!label) return "";
              return label.replace(/(\d)'(?=\d{3}(\D|$))/g, "$1");
            },
            label: function (context: any) {
              let label = context.dataset.label || "";

              if (label) label += ": ";
              if (context.parsed.y !== null) {
                label += new Intl.NumberFormat("en-US").format(
                  context.parsed.y.toFixed(tooltipPrecision ?? 0)
                );
              }

              return label;
            },
          },
        },
      },
      interaction: {
        intersect: false,
        mode: "index",
      },
      animation: false,
      scales: {
        ...yAxes,
        x: {
          type: xMinMax ? "linear" : "category",
          min: xMinMax?.min ?? (undefined as any),
          max: xMinMax?.max ?? (undefined as any),
          afterBuildTicks: (scale: any) => {
            if (xMinMax && Array.isArray(xMinMax.ticks) && xMinMax.ticks.length > 0) {
              scale.ticks = xMinMax.ticks
                .filter((value) => Number.isFinite(value))
                .map((value) => ({ value }));
              return;
            }
          },
          title: {
            display: xAxis ? true : false,
            text: xAxis,
          },
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: true,
            borderDash: [5, 5],
            color: "#0000005c",
          },
          ticks: {
            display: true,
            color: "black",
            padding: 10,
            format: {
              useGrouping: false,
            },
            font: {
              size: 14,
              family: "Roboto",
              style: "normal",
              lineHeight: 2,
            },
          },
        },
      },
    },
  };
}

export default configs;
